import React from "react";

let elementCache = {};

class NnAudioElement extends React.Component {
  constructor(props) {
    super(props);
    this.srcfolder = props.srcfolder;
    this.octave = props.octave;
    this.note = props.note;
    elementCache[this.cacheKey] = this;
  }
  render() {
    var ele = (
      <audio
        id={this.note + this.octave}
        src={`${this.srcfolder}/0${this.octave}_${this.note}.mp3`}
        ref={element => {
          this.ele = element;
        }}
        autostart="false"
      />
    );
    return ele;
  }
  get cacheKey() {
    return NnAudioElement.getCacheKey(this.octave, this.note);
  }
  static getCacheKey(octave, note) {
    return `${octave}_${note}`;
  }
  getAudioElement() {
    return elementCache[this.cacheKey].ele;
  }
  static getAudioElement(octave, note) {
    let k = NnAudioElement.getCacheKey(octave, note);
    let e = elementCache[k];
    return e;
  }
  play() {
    this.getAudioElement().play();
  }
}

export default NnAudioElement;



// WEBPACK FOOTER //
// ./src/NnAudioElement.js